import React, { useState } from "react";
import AuthenticationForm from "components/organisms/AuthenticationForm";
import LoginForm from "components/organisms/LoginForm";
import useIsStoomHostname from "hooks/useIsStoomHostname";

const LoginPage = () => {
    const [step, setStep] = useState<number>(1);
    const { logoToRender } = useIsStoomHostname();

    return (
        <>
            <div className="flex flex-col items-center justify-center h-screen bg-background-main">
                <div className="flex flex-col items-center pb-6">
                    <img src={logoToRender} alt="Logo" style={{ width: '150px' }} />
                </div>

                {step === 1 &&
                    <LoginForm setStep={setStep} />
                }

                {step === 2 &&
                    <AuthenticationForm setStep={setStep} />
                }
            </div>
        </>
    );
};

export default LoginPage;
